import { FC, useContext, useEffect, useMemo } from 'react';
import {
  AuthenticationContext,
  useGetActiveHeroConversations,
  useGetAssociateIncomingOpenTransferRequests,
  useQueriesCache,
  useVsWebsocket,
} from '@vs-online-only-app/state';
import { TransferRequestCard } from './incoming-conversation/TransferRequestCard';
import SuccessBanner, {
  SuccessBannerType,
} from './incoming-conversation/SuccessBanner';
import { TransferOutcomeCard } from './incoming-conversation/TransferOutcomeCard';

export const IncomingTransfer: FC = () => {
  const { incomingTransfersUpdateEvents } = useVsWebsocket();
  const { data: transferRequests } =
    useGetAssociateIncomingOpenTransferRequests();
  const { user: associate } = useContext(AuthenticationContext);
  const getActiveHeroConversationsQuery = useGetActiveHeroConversations();
  const { invalidateHeroConversation } = useQueriesCache();

  const transferRequest = useMemo(() => {
    const lastTransferRequest = transferRequests?.[0];
    if (!lastTransferRequest) {
      return;
    }

    return {
      ...lastTransferRequest,
      ...incomingTransfersUpdateEvents
        ?.filter((updateEvent) => updateEvent.id === lastTransferRequest?.id)
        .reverse()[0],
    };
  }, [transferRequests, incomingTransfersUpdateEvents]);

  useEffect(() => {
    if (transferRequest?.outcome === 'accepted') {
      // //we invalidate the cached hero conversation because if the request has been accepted,
      // //the conversation details will be out of date
      invalidateHeroConversation(transferRequest.conversation);
      getActiveHeroConversationsQuery.refetch();
    }
  }, [transferRequest?.outcome]);

  if (!transferRequest) {
    return null;
  }

  if (transferRequest.open) {
    return <TransferRequestCard event={transferRequest} />;
  }

  if (transferRequest.accepted && transferRequest.accepted === associate?.id) {
    return (
      <SuccessBanner
        type={SuccessBannerType.Transfer}
        conversationId={transferRequest.conversation}
        requesterId={transferRequest.creator}
      />
    );
  }

  return <TransferOutcomeCard event={transferRequest} />;
};
